import Controller from '@ember/controller';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { isEmpty } from '@ember/utils';
import { sortByProperties } from 'donor-elf-web/lib/array-utils';
import { type BalanceAdjustmentRouteModel } from 'donor-elf-web/routes/admin/balance-adjustments';

export default class BalanceAdjustmentController extends Controller {
  model!: BalanceAdjustmentRouteModel;

  queryParams = ['q', 'page'];
  @tracked q = '';
  @tracked page = 1;
  perPage = 25;

  // sortBy: Object.freeze(['fund.name:asc']),
  get sortedItems() {
    return sortByProperties(this.model.items, ['fund.name:asc']);
  }

  get filteredItems() {
    let { q, sortedItems } = this;

    if (isEmpty(q) || q.length < 3) {
      return sortedItems;
    }
    q = q.toLowerCase();
    return sortedItems.filter((item) => {
      return item.fund.nameLowerCase.indexOf(q) >= 0;
    });
  }

  get pagedItems() {
    let offset = (this.page - 1) * this.perPage;
    return this.filteredItems.slice(offset, offset + this.perPage);
  }

  get totalPages() {
    return Math.ceil(this.filteredItems.length / this.perPage);
  }

  @action
  templateWillDestroy() {
    this.q = '';
    this.page = 1;
  }

  @action
  changePage(pageNumber: number) {
    this.page = pageNumber;
  }

  @action
  handleSearchInput(e: any) {
    this.q = e.target.value;
    this.page = 1;
  }
}
